import { NgModule, Optional, SkipSelf } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';
import { AuthModule } from 'app/core/auth/auth.module';
import { IconsModule } from 'app/core/icons/icons.module';
import { TranslocoCoreModule } from 'app/core/transloco/transloco.module';
import { environment } from 'environments/environment';
import { LIB_VERSION } from '../../../version';

if (environment.sentryDSN.length > 0) {
  const release = LIB_VERSION;
  Sentry.init({
    dsn: environment.sentryDSN,
    environment: environment.env,
    release: 'admin@v' + release,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: [environment.api],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

@NgModule({
  imports: [AuthModule, IconsModule, TranslocoCoreModule],
})
export class CoreModule {
  /**
   * Constructor
   */
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    // Do not allow multiple injections
    if (parentModule) {
      throw new Error(
        'CoreModule has already been loaded. Import this module in the AppModule only.',
      );
    }
  }
}
